<template>
  <div>
    <ks-input-field 
        :dataSource="dataSourceAddressLine1" 
        type="text" 
        label="Address Line 1"
    />
    <ks-input-field 
        :dataSource="dataSourceAddressLine2" 
        type="text" 
        label="Address Line 2"
    />
    <ks-input-field 
        :dataSource="dataSourceCity" 
        type="text" 
        label="City"
    />
    <ks-select-field
        :dataSource="dataSourceState"
        type="select"
        :options="options"
        label="State" 
    />
    <ks-input-field 
        :dataSource="dataSourcePostalCode" 
        type="text" 
        label="Postal Code"
    />
    <ks-button 
        size="sm" 
        @onClick="validate_input()" 
        v-if="enableValidateButton"
        :disabled="loading"
    >
      Validate Address 
      <i class="fas fa-address-book" v-if="!loading"></i> 
      <i class="fa fa-spinner" aria-hidden="true" v-else></i>
    </ks-button>

    <div :class="[{'valid-feedback': isValid, 'invalid-feedback d-block': !isValid }]">
      <ul>
        <li v-for="(error, index) in errs" :key="_uid+'error_'+index">{{ error }}</li>
      </ul>
    </div>

    <ks-modal
        ref="addressSugestionModal"
        position="centered"
        :showHeader="false"
        :enableClose="true"
    >
        <ks-modal-header
            title="Address Sugestion"
        />
        <ks-modal-body>
            {{ suggestionAddressMessage }}
        </ks-modal-body>
        <ks-modal-footer>
          <ks-button color="primary" size="sm" @onClick="changeAddress()">Change and Close</ks-button>
          <ks-button color="danger" size="sm" @onClick="close()">Cancel</ks-button>
        </ks-modal-footer>
    </ks-modal>

  </div>
</template>

<script>
export default {
  /**
   tag
   name: ks-input-address
   description: input for address component
   **/
  name: 'ks-input-address',
  props: {
    dataSourceAddressLine1:{
      type: String,
      default: 'address_line1'
    },
    dataSourceAddressLine2:{
      type: String,
      default: 'address_line2'
    },
    dataSourceCity:{
      type: String,
      default: 'city'
    },
    dataSourceState:{
      type: String,
      default: 'state'
    },
    dataSourcePostalCode:{
      type: String,
      default: 'postal_code'
    },
    enableValidateButton:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    'data_provider_ref.l_localRecord': function(val){

      /*if( val[this.dataSourceAddressLine1] && val[this.dataSourceAddressLine1].length > 0 && 
          val[this.dataSourceAddressLine2] && val[this.dataSourceAddressLine2].length > 0 &&
          val[this.dataSourceCity] && val[this.dataSourceCity].length > 0 &&
          val[this.dataSourceState] && val[this.dataSourceState].length > 0 &&
          val[this.dataSourcePostalCode] && val[this.dataSourcePostalCode].length > 0
      ){
        if(this.enableValidateButton){
          this.showValidateButton = true;
        }
      }else{
        this.showValidateButton = false;
      }*/
    }
  },
  computed:{
    data_provider_ref() {
      return this.$parent.data_provider_ref;
    },
    type() {
      return this.$parent.type;
    }
  },
  methods: {
    async validate_input(){
      try{
          this.loading = true;
          this.errs = [];
          this.addressSuggestion = {};
          this.suggestionAddressMessage = null;
          this.isValid = true;
          let record = this.$parent.data_provider_ref.getLocalRecord();
          let res = await app.sdk.market['contact_address_validate'](app.auth.token,{
            'campaign_id': 1,
            'address_line1': record[this.dataSourceAddressLine1],
            'address_line2': record[this.dataSourceAddressLine2],
            'city': record[this.dataSourceCity],
            'state': record[this.dataSourceState],
            'postal_code': record[this.dataSourcePostalCode]
          });
          if(res.validate[0] && res.validate[0].success){
            if(res.validate[0].address_suggestion){
              let asObject = JSON.parse(res.validate[0].address_suggestion);
              if(asObject.address_line1 && asObject.address_line1.trim().toLowerCase() != record[this.dataSourceAddressLine1].trim().toLowerCase() ||
                asObject.address_line2 && asObject.address_line2.trim().toLowerCase() != record[this.dataSourceAddressLine2].trim().toLowerCase() ||
                asObject.city && asObject.city.trim().toLowerCase() != record[this.dataSourceCity].trim().toLowerCase() ||
                asObject.state && asObject.state.trim().toLowerCase() != record[this.dataSourceState].trim().toLowerCase() ||
                (asObject.postal_code && asObject.postal_code[0].trim().toLowerCase() != record[this.dataSourcePostalCode].trim().toLowerCase() && asObject.postal_code && asObject.postal_code[1].trim().toLowerCase() != record[this.dataSourcePostalCode].trim().toLowerCase()) 
              ){  
                this.addressSuggestion = asObject;
                this.suggestionAddressMessage = `We've found a direction hint. Would you like to change
                ${record[this.dataSourceAddressLine1]?record[this.dataSourceAddressLine1]:''} ${record[this.dataSourceAddressLine2]?record[this.dataSourceAddressLine2]:''}, ${record[this.dataSourceCity]}, ${record[this.dataSourceState]}, ${record[this.dataSourcePostalCode]} to 
                ${asObject.address_line1?asObject.address_line1:''} ${asObject.address_line2?asObject.address_line2:''}, ${asObject.city}, ${asObject.state}, ${asObject.postal_code[0]}?`;
                this.$refs.addressSugestionModal.show();
              }
            }
            this.loading = false;
            return true;
          }else{
            this.loading = false;
            this.isValid = false;
            this.errs.push(res.validate[0]? res.validate[0].error: 'Invalid Address');
            return false;
          }
      }catch(err){
        console.log(err);
        return false;
      }
    },
    changeAddress(){
      let record = {};
      record[this.dataSourceAddressLine1] = this.addressSuggestion.address_line1;
      record[this.dataSourceAddressLine2] = this.addressSuggestion.address_line2;
      record[this.dataSourceCity] = this.addressSuggestion.city;
      record[this.dataSourceState] = this.addressSuggestion.state;
      record[this.dataSourcePostalCode] = this.addressSuggestion.postal_code[0];
      this.$parent.data_provider_ref.updateLocalRecord(record);
      this.close();
    },
    close(){
      this.errs = [];
      this.addressSuggestion = {};
      this.suggestionAddressMessage = null;
      this.isValid = true;
      this.$refs.addressSugestionModal.close();
    }
  },
  async mounted(){
  },
  data() {
    return {
      showValidateButton: false,
      isValid: true,
      suggestionAddressMessage: null,
      addressSuggestion: {},
      errs:[],
      loading:false,
      options: async ()=>{
        try{
          let data = await app.data.list('market.geolocale', { 'campaign_id': 1 , 'parent_geolocale_id': 133, 'row_count_skip': 0,  'row_count_take': 9999 });
          return data.list.map((state) => {return {'label':state.geolocale, 'value':state.geolocale_abbr}});
        }catch(err){
          console.log(err);
          return [];
        }
      }
    }
  }
}
</script>

